export default "__VITE_ASSET__Dk9O1O_L__"